"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "event-chart"
  }, [_c("p", [_vm._v("Current Day View")]), _c("el-table", {
    attrs: {
      data: _vm.list,
      "max-height": "380"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "time",
      label: "Time"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: new Date().toLocaleDateString(),
      label: new Date().toLocaleDateString()
    }
  })], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;